export default "__VITE_ASSET__hs5UG6xj__"